<template>
	<div>
		<h4 class="mb-3">{{ $t('map-columns') }}</h4>
		<p class="text-muted small mb-3">{{ instructions }}</p>

		<b-spinner v-if="loadingFields" small class="mb-3"></b-spinner>

		<div v-else class="table-responsive mb-3">
			<table class="table table-sm">
				<thead class="thead-light">
					<tr>
						<th>{{ $t('field') }}</th>
						<th style="width:40%">{{ $t('csv-column') }}</th>
						<th>{{ $t('sample-value') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="field in fieldDefs" :key="field.key">
						<td>
							{{ field.label }}
							<span v-if="field.required" class="text-danger ml-1">*</span>
						</td>
						<td>
							<b-form-select
								v-model="columnMap[field.key]"
								:options="columnOptions"
								size="sm"
								:state="field.required ? columnMap[field.key] !== null : null"
							></b-form-select>
						</td>
						<td class="text-muted small">{{ previewValueFor(field.key) }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="d-flex">
			<b-button variant="outline-secondary" class="mr-2" @click="$emit('back')">← {{ $t('back') }}</b-button>
			<b-button variant="primary" :disabled="!mappingValid || validating" @click="$emit('validate')">
				<b-spinner v-if="validating" small class="mr-1"></b-spinner>
				{{ validating ? $t('validating') : `${$t('next')}: ${$t('review')} →` }}
			</b-button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		fieldDefs:     { type: Array,   required: true },
		columnOptions: { type: Array,   required: true },
		columnMap:     { type: Object,  required: true },
		validating:    { type: Boolean, default: false },
		mappingValid:  { type: Boolean, default: false },
		previewRows:   { type: Array,   default: () => [] },
		loadingFields: { type: Boolean, default: false },
		instructions:  { type: String,  required: true },
	},
	methods: {
		previewValueFor(key) {
			const idx = this.columnMap[key];
			if (idx === null || !this.previewRows.length) return '';
			return this.previewRows[0][idx] ?? '';
		},
	},
};
</script>
